// Funzione per leggere un file JSON
async function readJSON(path) {
    try {
        const response = await fetch(path);
        if (!response.ok) throw new Error('Network response was not ok');

        const data = await response.json();
        const currentPath = window.location.pathname;

        // Determina il valore di filtro in base alla path del browser
        const filterValue = currentPath.includes('warranty') ? 'warranty' : currentPath.includes('wrong') ? 'wrong' : 'return';


        // Filtra gli oggetti con la chiave "form_group" === "return"
        const filteredData = data.filter(item => item.form_group === filterValue);
        //console.log(filteredData)
        return filteredData;
    } catch (error) {
        console.log('Error fetching JSON:', error);
        throw error;
    }
}

const scrollToTop = function() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // For smooth scrolling
    });
}

// Funzione principale di inizializzazione dell'app
const initApp = async () => {
    const RECAPTCHA_KEY = await getRecaptchaConfig()

    initializeStepper();
    disableStepperContentClicks();
    loadRecaptchaScript(RECAPTCHA_KEY);

    window.submitOrder = (token) => {
        document.getElementById('recaptchain').value = token;
    };

    window.onloadCallback = () => {
        loadRecaptcha(document.documentElement.lang, RECAPTCHA_KEY);
    };

    const rmaModalContainer = document.getElementById('rma-modal-container');
    if (rmaModalContainer) {
        document.body.appendChild(rmaModalContainer);
    }

    initAppRma();
};

// Funzione per inizializzare lo stepper
const initializeStepper = () => {
    const stepper = document.getElementById('stepper');
    new CDB.Stepper(stepper);
};

// Funzione per disabilitare i click sul contenuto dello stepper
const disableStepperContentClicks = () => {
    document.querySelectorAll('.stepper-content').forEach(item => {
        item.onclick = false;
    });
};

// Funzione per caricare il script di reCAPTCHA
const loadRecaptchaScript = (token) => {
    const recaptchaScript = document.createElement('script');
    recaptchaScript.src = `https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit&hl=${document.documentElement.lang}`;
    document.head.appendChild(recaptchaScript);
};

// Funzione per caricare e configurare reCAPTCHA
const loadRecaptcha = (lang, token) => {
    const recaptcha = document.getElementById('recaptchakey');
    recaptcha.dataset.sitekey = token;
    grecaptcha.render(recaptcha, { sitekey: token });
};

// Funzione di inizializzazione dell'RMA
const initAppRma = async () => {
    const reasons = await readJSON('/apps/returns/store-options?locale='+Shopify.locale);
    setupEventListeners(reasons);
};

// Funzione per impostare i listener degli eventi
const setupEventListeners = (reasons) => {
    document.getElementById('next1').addEventListener("click", () =>{
        stepControl1(reasons);
        scrollToTop();
    });

    document.getElementById('next2').addEventListener("click", () => {
        const selectedItems = stepControl2();
        if (selectedItems){
            if (selectedItems.length > 0) {
                navigateToStep(3);
                designRowsRma(selectedItems, 'listrma', reasons);
                scrollToTop();
            }
        }
    });

    document.getElementById('next2back').addEventListener("click", reloadPage);
    document.getElementById('next3back').addEventListener("click", () => navigateToStep(2));
    document.getElementById('next3').addEventListener("click", () => {
        let validate_response = validateAddress();
        if(validate_response){
            const selectedItems = stepControl2();
            if (selectedItems){
                if (selectedItems.length > 0) {
                    designRowsRma(selectedItems, 'listrma2', reasons);
                    resume()
                    navigateToStep(4);
                    scrollToTop();
                }
            }
        }
        
    });

    document.getElementById('next4back').addEventListener("click", () => navigateToStep(3));
    document.getElementById('next4').addEventListener("click", () => {
        validateAddress();
        const selectedItems = stepControl2();
        if (selectedItems){
            if (selectedItems.length > 0) {
                showLoader(2);
                sendDataRma(selectedItems);
                scrollToTop();
            }
        }
    });

    document.getElementById("rma-modal-close").addEventListener("click", () => {
        document.getElementById('rma-modal-container').classList.remove("open");
    });
};

// Funzione per gestire gli errori
const handleErrorLogin = (status, code) => {
    const errorMessages = document.getElementById('error-messages').dataset;
    const errorCode = { 429: 'server_error', 500: 'server_error', 404: 'order_not_found', 430: 'recaptcha_error', 409: 'server_error' };

    if (errorCode[status]) {
        const errorKey = errorCode[status];
        console.log(errorKey, errorMessages[errorKey]);
        displayModal(errorMessages['tit_modal_error'], errorMessages[errorKey], code);
        hideLoader();
        resetRecaptcha();
        navigateToStep(1);
        
        throw new Error(errorMessages[errorKey]);
    }
};

const handleError = (status, code) => {
    console.log(status, code)
    const errorMessages = document.getElementById('error-messages').dataset;
    const errorCode = { 429: 'server_error', 500: 'server_error', 404: 'order_not_found', 430: 'recaptcha_error', 409: 'server_error' };

    if (errorCode[status]) {
        const errorKey = errorCode[status];
        console.log(errorKey, errorMessages[errorKey]);
        displayModal(errorMessages['tit_modal_error'], errorMessages[errorKey], code);
        hideLoader();
        throw new Error(errorMessages[errorKey]);
    }
};

// Funzione per nascondere il loader
const hideLoader = () => {
    const loader = document.getElementById('rma_loader');
    if (loader) loader.classList.add('d-none');
};

// Funzione per resettare il reCAPTCHA
const resetRecaptcha = () => {
    const recaptchaElement = document.getElementById('recaptchain');
    if (recaptchaElement) grecaptcha.reset();
};

// Funzione per navigare al passo successivo
const navigateToStep = (stepNumber) => {
    const step = document.getElementById(stepNumber.toString());
    const stepNode = step.querySelector('.step-node');
    if (stepNode) stepNode.click();
};

// Funzione di controllo del primo passo
const stepControl1 = async (reasons) => {
    const email = document.getElementById('rma_mail');
    const numOrder = document.getElementById('n_ordine');
    const recaptcha = document.getElementById('recaptchain');
    const type_form = document.getElementById('type_form');
    let calltoaction = document.getElementById('rma-modal-call-to-action')
    
    calltoaction.classList.add('d-none')

    if (validateEmail(email) && numOrder.value && recaptcha.value) {
        showLoader(1);

        const data = { order_number: numOrder.value, email: email.value, recaptcha: recaptcha.value, type_form: type_form.value };
        try {
            const response = await fetch("/apps/returns/get-order", {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            });
            if (![200, 201].includes(response.status)) {
                const responseData = await response.json();
            
                handleErrorLogin(response.status, responseData.error.code);
                
            } else {
                const responseData = await response.json();
                processOrderData(responseData, reasons);
            }
        } catch (error) {
            
            console.log('Error processing order:', error);
        }
    } else {
        handleValidationError(email, numOrder, recaptcha);
    }
};

// Funzione per mostrare il loader
const showLoader = (type) => {
    if(type === 1){
        const loader = document.getElementById('rma_loader');
        if (loader) loader.classList.remove('d-none');
    }
    if(type === 2){
        const loader2 = document.getElementById('rma_loader2');
        if (loader2) loader2.classList.remove('d-none');
    }
};

const createLoader = (row_id) => {
    const loader = document.createElement('div');
    loader.classList.add('spinner-border', 'd-none', 'ms-4'); 
    loader.setAttribute('role', 'status');
    loader.setAttribute('id', `image_loader_${row_id}`);

    const span = document.createElement('span');
    span.classList.add('visually-hidden');
    span.textContent = 'Loading...'; 

    loader.appendChild(span);

    document.body.appendChild(loader);

    return loader; 

}


// Funzione per gestire l'errore di validazione
const handleValidationError = (email, numOrder, recaptcha) => {
    const errorMessages = document.getElementById('error-messages').dataset;
    if (!recaptcha.value && validateEmail(email) && numOrder.value) {
        displayModal(errorMessages['tit_modal_error'], errorMessages['recaptcha_error']);
    } else {
        displayModal(errorMessages['tit_modal_error'], errorMessages['user_data_error']);
    }
    navigateToStep(1);
};

// Funzione per processare i dati dell'ordine
const processOrderData = (data, reasons) => {
    const errorMessages = document.getElementById('error-messages').dataset;
    if(data.max_fulfillments) {
        const num_colli = document.querySelector('[name="num_colli"]');
        const num_colli_wrapper = document.querySelector('.card.num_colli_wrapper');

        if (num_colli) {
            num_colli.setAttribute('max', data.max_fulfillments); 
            num_colli.value = 1;
        }
        
        if(num_colli_wrapper && data.max_fulfillments == 1) {
            document.querySelector('.card.num_colli_wrapper').style.display = 'none';
        }
    }

    hideLoader();
    switch (data['return_type']) {
        case 'EMPTY':
            console.log("Non ci sono altri resi.");
            navigateToStep(2);
            designRowsOrder(data['products'], reasons);
            stepControl3(data['shipping'], data['email']);
            document.getElementById('order_id').value = data['order_id'];
            document.getElementById('customer_id').value = data['customer_id'];
            break;

        case 'PARTIAL':
            console.log("Il reso è parziale. Alcuni articoli sono stati resi.");
            // Aggiungi qui la logica per gestire un reso parziale
            let removeClose = document.getElementById('rma-modal-close')
            removeClose.classList.add('d-none')
            let contentModal = generateReturnsHTML(data)
            displayModal(errorMessages['partial_title'], contentModal)
            let partial_new = document.getElementById('partial_new')
            partial_new.addEventListener('click', ()=>{
                console.log('nuovo reso')
                navigateToStep(2);
                designRowsOrder(data['products'], reasons);
                stepControl3(data['shipping'], data['email']);
                document.getElementById('order_id').value = data['order_id'];
                document.getElementById('customer_id').value = data['customer_id'];
                let removeClose = document.getElementById('rma-modal-close')
                removeClose.classList.remove('d-none')
                document.getElementById('rma-modal-container').classList.remove("open");
            })
            break;
        
        case 'COMPLETED':
            console.log("Il reso è completato. Tutti gli articoli sono stati resi.");
            // Aggiungi qui la logica per gestire un reso completato
            let removeClose2 = document.getElementById('rma-modal-close')
            removeClose2.classList.add('d-none')
            let contentModal2 = generateReturnsHTML(data)
            displayModal(errorMessages['completed_title'], contentModal2)
            break;
    }
};

function generateReturnsHTML(data) {
    const errorMessages = document.getElementById('error-messages').dataset;
    // Inizializza una stringa vuota per l'HTML
    let html = '';

    html += '<div class="container" id="container_partial">';
    html += `<p>${errorMessages['partial_list_title']}</p>`;
    html += '<ul class="list-group" id="list_partial">';

    // Itera su ogni reso in `other_returns`
    data['other_returns'].forEach(returnItem => {
        html += '<li class="list-group-item d-flex justify-content-between align-items-center">';
        html += returnItem['name']; // Nome del reso
        html += `<a href="${Shopify.routes.root}${returnItem['return_path']}" class="ms-4 btn btn-secondary">${errorMessages['partial_view']}</a>`;
        html += '</li>';
    });

    html += '</ul>';
    

    if(data['return_type'] === 'PARTIAL'){
        html += `<div class="btn btn-primary mt-4" id="partial_new">${errorMessages['partial_new_return_title']}</div>`;
    }

    html += '</div>';

    return html;
}

// Funzione per validare l'email
const validateEmail = (input) => {
    const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    return input.value.match(mailFormat);
};

// Funzione per visualizzare un messaggio di errore
const displayModal = (title, message, code=null) => {
    const errorModal = document.getElementById('rma-modal-container');
    errorModal.classList.add("open");
    document.getElementById('rma-tit-modal').innerHTML=title
    if(code){
        document.getElementById('rma-modal-content').innerHTML = `<p>${message}<br/>Error Code:${code}</p>`;
    }else{
        document.getElementById('rma-modal-content').innerHTML = `<p>${message}</p>`;
    }
    
};

// Funzione per il controllo del secondo passo
const stepControl2 = () => {
    const errorMessages = document.getElementById('error-messages').dataset;
    const rows = [];
    const selectsqty = document.querySelectorAll('.select-rma-qty');
    
    const currentPath = window.location.pathname;
    const filterValue = currentPath.includes('warranty') ? 'warranty' : currentPath.includes('wrong') ? 'wrong' : 'return';
   
    
    let hasSelectionNotes = [];
    let hasSelectionqty = [];
    let hasImage = []
    const selectsnotes = document.querySelectorAll('.note-rma');
    const righe = document.querySelectorAll('#listorder tr');
    
    selectsqty.forEach((select, index) => {
       
        if (parseInt(select.value) > 0) {
            hasSelectionqty.push(true)
            if(filterValue ==='warranty' ||filterValue ==='wrong' ){
                if (selectsnotes[index].value.length >= 3) {
                    hasSelectionNotes.push(true);
                }
                let tdElements = righe[index].querySelector('td[td-row]')
                if(tdElements){
                    
                    const inputElement = tdElements.querySelector('input');
                    if (inputElement) {
                        //console.log(`Il td con td-row= contiene un input.`);
                        hasImage.push(true)
                    }
                    
                    const imgElement = tdElements.querySelector('img');
                    if (imgElement) {
                        //console.log(`Il td con td-row contiene un'immagine.`);
                    }
                }
            }else{
                hasSelectionNotes.push(true);
            }
            if(hasSelectionNotes.length === hasSelectionqty.length && hasImage.length === 0){
                const row = extractRowData(select);
                rows.push(row);

                let child_rows = []

                if(righe[index].querySelector('script')) {
                    const scriptTag = righe[index].querySelector('script');
                    const scriptContent = scriptTag.textContent;
                    const parsedData = JSON.parse(scriptContent);

                    parsedData.forEach((child) => {
                        let child_row = { ...row };
                        child_row.variant_id = child.variant_id;
                        child_row.product_id = child.product_id;
                        child_row.img = child.img;
                        child_row.id_media = null;
                        child_row.title = child.title;
                        child_row.sku = child.sku;
                        child_row.price = parseFloat(child.amount).toFixed(2);
                        child_row.is_customization = true;
                        child_row.note = '';
                        child_rows.push(child_row);
                    });
                }

                rows.push(...child_rows);
            }
        }
    });

    if (hasSelectionNotes.length === 0 || hasSelectionqty.length === 0 || hasSelectionNotes.length !== hasSelectionqty.length || hasImage.length >0) {
        navigateToStep(2);
        if(hasSelectionNotes.length === 0 || hasSelectionNotes.length < hasSelectionqty.length){
            displayModal(errorMessages['tit_modal_error'],errorMessages['note_not_selected']);
        }
        if(hasSelectionqty.length === 0){
            displayModal(errorMessages['tit_modal_error'],errorMessages['quantity_not_selected']);
        }
        if(hasImage.length > 0){
            displayModal(errorMessages['tit_modal_error'],errorMessages['image_not_loaded']);
        }
    }else{
        return rows;
    }
    
    
};

// Funzione per estrarre i dati della riga
const extractRowData = (select) => {
    const row = select.closest('tr');
    const imgElement = document.getElementById(`image_${row.dataset.row}`);
    const selectReason = row.querySelector('td .select-reason')
    const option = selectReason.options[selectReason.selectedIndex].dataset
    const option_v = selectReason.options[selectReason.selectedIndex]
    const img_tag = document.getElementById(`image_${row.dataset.row}`)
    
    let img_media = null
    if(img_tag){
        img_media = img_tag.getAttribute('data-id_media')
    }
    
    const rowData = {
        product_id: row.dataset.product_id,
        variant_id: row.dataset.row,
        img: row.querySelector('td.rma-image img').src,
        id_media: img_media,
        title: row.querySelector('td[data-product] .fw-bold').textContent,
        sku: row.querySelector('td[data-product] .sku-rma').textContent,
        price: row.querySelector('td[data-product] .price-rma').dataset.originalPrice,
        reason: option_v.value,
        reason_label: option['label'],
        reason_platform_value: option['platform_value'],
        automatic_confirmation: option['automatic_confirmation'],
        attached_required: option['attached_required'],
        qty: select.value,
        resolution: 'Refund',
        note: row.querySelector('textarea').value,
        rma_img: imgElement ? imgElement.src : false,
        rma_img_shopify:[]
    };
    return rowData;
};

// Funzione per disegnare le righe dell'ordine
const designRowsOrder = async (products, reasons) => {
    const container = document.getElementById('listorder');
    container.innerHTML = '';

    var valids_prods = products.filter(prod  => !prod.is_not_returnable && prod.is_returnable);
    const customizations = valids_prods.filter(prod => prod.sku.includes('CUSTOMIZATION'));
    valids_prods = valids_prods.filter(prod => !customizations.includes(prod));

    valids_prods.forEach(
        (prod, index) => {
            if(prod.line_item_group_id) {
                let childs = customizations.filter(prod_custom => prod_custom.line_item_group_id == prod.line_item_group_id);
                valids_prods[index].childs = childs;
            }
        }
    )

    
    valids_prods.forEach((product) => {
        const row = createOrderRow(product, reasons);
        container.appendChild(row);
        const selectElements = document.querySelectorAll('#listorder .select-reason');
        selectElements.forEach(selectElement => {
            updateContainer(selectElement);
        });
    });
};

// Funzione per creare la riga dell'ordine
const createOrderRow = (product, reasons) => {
    //console.log(product)
    const row = document.createElement('tr');
    row.dataset.row = product['variant_id'];
    row.dataset.product_id = product['product_id'];

    let hasAttachedImage = reasons.some(reason => reason['img_attached'] !== false);
    let additionalTd = '';
    if (hasAttachedImage) {
        additionalTd = `
            <td td-row=${product['variant_id']}>
                
            </td>
        `;
    }
    const optionsHtmlReason = reasons.map(reason => `
        <option 
            value="${reason['id']}"
            data-variat_id="${product['variant_id']}"
            data-automatic_confirmation="${reason['automatic_confirmation']}"
            data-platform_value="${reason['value']}"
            data-label="${reason['label']}"
            data-attached_required="${reason['img_attached']}"
        >
            ${reason['label']}
        </option>
    `).join('');

    let qtyHtml = ''
    for (let s = 0; s <= parseInt(product['quantity']); s++) {
        qtyHtml += `<option value="${s}">${s}</option>`
    }

    var price = parseFloat(product['amount']).toFixed(2);
    var has_customizations = false;
    if(product.childs) {
        product.childs.forEach( (child) => {
            price = (parseFloat(price) + parseFloat(child["amount"])).toFixed(2);
        });
        has_customizations = true;
    }

    row.innerHTML = `
        <td class="text-center rma-image"><img src="${product['img']}" alt="${product['title']}" width="100px" /></td>
        <td data-product>
            <div class="fw-bold">${product['title']}</div>
            <div class="sku-rma">${product['sku']}</div>
            <div class="price-rma" data-original-price="${product['amount']} ${product['currency']}">${price} ${product['currency']}</div>
            ${has_customizations ? '<div class="customization-label">Includes Customizations</div>' : ''}
        </td>
        <td class="data-reason">
            <div class="reason-container">
                <label for="floatingSelect"></label>
                <select class="form-select select-reason" onchange="updateContainer(this)">
                    ${optionsHtmlReason}
                </select>
            </div>
        </td>
        <td data-qty>
            <div class="qty-container">     
                <label for="floatingSelect2"></label>
                <select class="form-select select-rma-qty">
                    ${qtyHtml}
                </select>
            </div>
        </td>
        <td note-change>
            <textarea name="note_${product['variant_id']}" rows="5" class="form-control note-rma"></textarea>
        </td>
        ${additionalTd}
    `;

    if(product.childs) {
        const scriptTag = document.createElement('script');
        scriptTag.type = 'application/json';
        scriptTag.textContent = JSON.stringify(product.childs);
        row.appendChild(scriptTag);
    }

    return row;
};

const updateContainer = (selectElement) => {
    console.log(selectElement)
    const errorMessages = document.getElementById('error-messages').dataset;
    const container = document.getElementById('listorder')
    const selectedValue = selectElement.value;
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const attachedRequired = selectedOption.getAttribute('data-attached_required');
    
    // Log di esempio
    //console.log('Selected value:', selectedValue);
    //console.log('Attached required:', attachedRequired);
    

    const row_id = selectedOption.getAttribute('data-variat_id')
    

    // const controlimg = document.getElementById('next2')
    // controlimg.classList.remove('d-none')

    if (attachedRequired === 'true') {
        // Mostra un contenuto speciale
        

        const td = container.querySelector(`td[td-row="${row_id}"]`);
        td.innerHTML = '';
        const fileInput = document.createElement('input');
      
        fileInput.type = 'file';
        fileInput.accept = '.jpg, .jpeg, .png, .webp'; 
        fileInput.setAttribute('class', 'form-control')
        fileInput.setAttribute('id', `file_${row_id}`);
        fileInput.setAttribute('title', 'Max 5MB');
        fileInput.style.display = 'none';
        
        const fileLabel = document.createElement('label');
        fileLabel.setAttribute('for', `file_${row_id}`);
        fileLabel.setAttribute('id', `label_file_${row_id}`)
        fileLabel.setAttribute('class', 'btn btn-secondary btn-sm')
        fileLabel.innerText = errorMessages['img_allowed_formats'] || 'Supported formats: jpg, jpeg, png, webp';


        const fileLabel2 = document.createElement('div');
        fileLabel2.setAttribute('id', `alert_file_${row_id}`)
        fileLabel2.setAttribute('class', 'alert-input-control')
        fileLabel2.innerHTML = errorMessages['input_alert_max_size'] || 'Max 5MB';
        const img_loader = createLoader(row_id);
        
        td.appendChild(fileLabel);
        td.appendChild(fileInput);
        td.appendChild(fileLabel2);
        td.appendChild(img_loader);

        fileInput.addEventListener('change', function(event) {
            const loaderImg = document.getElementById(`image_loader_${row_id}`) 
            loaderImg.classList.remove('d-none')
            const file = event.target.files[0];
            if (file) {
                if (file.size > 5 * 1024 * 1024) { 
                    
                    displayModal(errorMessages['tit_modal_error'],errorMessages['img_max_size'])
                    return;
                }
                const formData = new FormData();
                formData.append('file', file);
                formData.append('order_id', document.getElementById('order_id').value)
                formData.append('variant_id', row_id)
                formData.append('order_name', document.getElementById('n_ordine').value)
                
                fetch('/apps/returns/upload_file', {
                    method: 'POST',
                    body: formData
                })
                .then(response => {
                    // Controlla se la risposta non è nella gamma 200-299
                    if (!response.ok) {
                        return response.json().then(responseData => {
                            handleError(response.status, responseData.error ? responseData.error.code : 'UNKNOWN_ERROR');
                            //throw new Error(`HTTP error! status: ${response.status}`);
                        });
                    }
                    return response.json(); 
                })
                .then(data => {
                    if (data.error) {
                        displayModal(errorMessages['tit_modal_error'],data.error)
                        return;
                    }
                    const img = document.createElement('img');
                    img.src = data.file_path; // Usa il percorso assoluto restituito dal server
                    img.alt = 'Uploaded Image';
                    img.width = '100';
                    img.setAttribute('class', 'uploaded-image');

                    img.setAttribute('id', `image_${row_id}`);
                    img.setAttribute('data-id_media',  data.id_media);
                    td.innerHTML = ''; // Rimuovi l'input file
                    td.appendChild(img); // Aggiungi il tag img
                    //controlimg.classList.remove('d-none')
                    loaderImg.classList.add('d-none')
                })
                .catch(error => {
                    console.log('Error:', error);
                });
            }
        });
    
    } else {
        // Nascondi o gestisci diversamente
        const img_check = document.getElementById(`image_${row_id}`);
        if (img_check){
            img_check.remove();
        } 
        const file = document.getElementById(`file_${row_id}`);
        if (file){
            file.remove();
        } 
    }
    /*
    const fileInput = container.querySelector('input[type="file"]');

    if (fileInput) {
        controlimg.classList.add('d-none')
        //console.log('Esiste un input di tipo file nella tabella.');
    } else {
        controlimg.classList.remove('d-none')
        //console.log('Nessun input di tipo file trovato nella tabella.');
    }*/
}

// Funzione per disegnare le righe del RMA
const designRowsRma = (rows, containerId, reasons) => {
    const container = document.getElementById(containerId);
    container.innerHTML = '';

    rows.forEach(row => {
        const rmaRow = createRmaRow(row, reasons);
        container.appendChild(rmaRow);
    });
};

// Funzione per creare la riga del RMA
const createRmaRow = (row, reasons) => {
    const rmaRow = document.createElement('tr');
    rmaRow.dataset.row = row['variant_id'];
    let hasAttachedImage = reasons.some(reason => reason['img_attached'] !== false);
    
    let additionalTd = '';
    if (hasAttachedImage && row['rma_img']) {
        additionalTd = `
            <td td-row=${row['variant_id']}>
                <img src="${row['rma_img']}" alt="Uploaded Image" width="100" class="uploaded-image"/> 
            </td>
        `;
    }
    rmaRow.innerHTML = `
        <td class="text-center rma-image">
            <img src="${row['img']}" alt="${row['title']}" width="100px" />
        </td>
        <td data-product>
            <div class="fw-bold">${row['title']}</div>
            <div class="sku-rma">${row['sku']}</div>
            <div class="price">${row["price"]}</div>
        </td>
        <td class="data-reason">
            ${row['is_customization'] ? 'Customization price' : row['reason_label']}
        </td>
        <td data-qty>
            ${row['qty']}
        </td>
        <td note-change>
            ${row['note']}
        </td>

        ${additionalTd}
    `;
    return rmaRow;
};

// Funzione per validare l'indirizzo
const validateAddress = () => {
    const errorMessages = document.getElementById('error-messages').dataset;
    const fields = ['phonevalrma', 'emailvalrma', 'cognomevalrma', 'indirizzovalrma', 'cittavalrma', 'capvalrma', 'provvalrma', 'paesevalrma'];
    const isValid = fields.every(field => document.getElementById(field).value.trim() !== '');
    
    if (!isValid) {
        displayModal(errorMessages['tit_modal_error'],errorMessages['shipping_fields_error']);
        return false
    }
    return true
};

// Funzione per ricaricare la pagina
const reloadPage = () => {
    location.reload();
};

// Funzione di controllo del terzo passo
const stepControl3 = (shipping, email) => {
    document.getElementById('nomevalrma').value = shipping.first_name;
    document.getElementById('cognomevalrma').value = shipping.last_name;
    document.getElementById('indirizzovalrma').value = shipping.address1;
    document.getElementById('cittavalrma').value = shipping.city;
    document.getElementById('capvalrma').value = shipping.zip;
    document.getElementById('provvalrma').value = shipping.province;
    document.getElementById('emailvalrma').value = email;
    document.getElementById('phonevalrma').value = shipping.phone;
    document.getElementById('paesevalrma').value = shipping.country_code;
};

const resume = () => {
    document.getElementById('rmaorder').innerText = document.getElementById('n_ordine').value
    document.getElementById('rmatel').innerText = document.getElementById('phonevalrma').value
    document.getElementById('rmaemail2').innerText = document.getElementById('emailvalrma').value
} 

const sendDataRma = (itemSelectedRma) =>{
    //console.log(itemSelectedRma)
    const errorMessages = document.getElementById('error-messages').dataset;
    let shippingData = {}
    shippingData['phone'] = document.getElementById('phonevalrma').value
    shippingData['email'] = document.getElementById('emailvalrma').value
    shippingData['name'] = document.getElementById('nomevalrma').value
    shippingData['surname'] = document.getElementById('cognomevalrma').value
    shippingData['address'] = document.getElementById('indirizzovalrma').value
    shippingData['city'] = document.getElementById('cittavalrma').value
    shippingData['zip'] = document.getElementById('capvalrma').value
    shippingData['province'] = document.getElementById('provvalrma').value
    shippingData['country'] = document.getElementById('paesevalrma').value

    const input_packages_number =  document.querySelector('[name="num_colli"]');
    if(input_packages_number) {
        shippingData['packages_number'] = input_packages_number.value
    }

    let payload = {}
    payload['host'] = window.location.href
    payload['order_id'] = document.getElementById('order_id').value
    payload['order_name'] = document.getElementById('n_ordine').value
    payload['customer_id'] = document.getElementById('customer_id').value
    //payload['items'] = itemsRma
    payload['shipping'] = shippingData
    payload['itemSelectedRma'] = itemSelectedRma
    payload['lang'] = Shopify.locale
    payload['type_form'] = document.getElementById('type_form').value
   
    const risposta = fetch("/apps/returns/set-rma", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(responseData => {
                let loader = document.getElementById('rma_loader2')
                loader.classList.add('d-none');
                handleError(response.status, responseData.error ? responseData.error.code : 'UNKNOWN_ERROR');
                
                //throw new Error(`HTTP error! status: ${response.status}`);
            });
        }
        return response.json(); 

       
    })
    .then(data => {
        
        let loader = document.getElementById('rma_loader2')
        loader.classList.add('d-none');
        let calltoaction = document.getElementById('rma-modal-call-to-action')
        calltoaction.setAttribute('href', data['call_to_action'])
        calltoaction.classList.remove('d-none')
        displayModal(errorMessages['tit_modal_success'],errorMessages['msg_success'])
        let resetNumOrder = document.getElementById('n_ordine')
        resetNumOrder.value = ''
        let resetEmail = document.getElementById('rma_mail')
        resetEmail.value = ''
        let step1 = document.getElementById('1')
        let stepMode = step1.querySelector('.step-node')
        stepMode.click()
    })
    .catch(error => {
        console.log('Error:', error);
    });

}

async function getRecaptchaConfig() {
    try {
        const response = await fetch("/apps/returns/store-info", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            
        });
        if (![200, 201].includes(response.status)) {
            const responseData = await response.json();
            
            handleErrorLogin(response.status, responseData.error.code);
            
        } else {
            const responseData = await response.json();
            return responseData
        }
    } catch (error) {
        console.log('Error recpcha capture store:', error);
    }
}


window.addEventListener('load', () => {
    initApp();
});